<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="fmh"><span class="epub-b">Contents</span></p>
<p class="cct"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cct"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="cct"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">Animal Control</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">No Friends’ Pets</a></p>
<p class="cct"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">Horns and Hair</span></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Side Effects</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Dog Attack</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Llama Mayhem</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Not Thinking</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Baby-Sitter</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Nurse Dog</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Woman’s Best Friend</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Elvis</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Alpaca Down</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Maternity Ward</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">What Makes a Vet</span></p>
<p class="cct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Not Dog Food</span></p>
<p class="cct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Christmas Mule</span></p>
<p class="cct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Personality Disorder</span></p>
<p class="cct"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Stay Off the Internet</span></p>
<p class="cct"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Then There Were Three</span></p>
<p class="cct"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">You Want Me to Do What?</span></p>
<p class="cct"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Attorney Cat</span></p>
<p class="cct"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Surprise</span></p>
<p class="cct"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Won’t Bite</span></p>
<p class="cct"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Unicorn</span></p>
<p class="cct"><span href="#/xhtml/adcard#adcd" title="Link target outside of Sample">Also by Jeff Wells</span></p>
<p class="cct"><span href="#/xhtml/abouttheauthor#author" title="Link target outside of Sample">About the Author</span></p>
<p class="cct"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0005127c